import { type MutationResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { setAccessoryDrawerState } from '../../../../Stores'

export const closeAccessoryDrawerResolver: MutationResolvers<ApolloResolverContext>['closeAccessoryDrawer'] = () => {
    console.debug('io-dashboards closeAccessoryDrawerResolver deprecated, use setAccessoryDrawerState')
    setAccessoryDrawerState(false)
    return false
}
